import { useEffect } from 'react';
import { usePerformance } from '@/hooks/usePerformance';

interface PerformanceMonitorProps {
  onMetric?: (name: string, value: number) => void;
}

export const PerformanceMonitor = ({ onMetric }: PerformanceMonitorProps) => {
  const metrics = usePerformance();

  useEffect(() => {
    // Report metrics when they become available
    Object.entries(metrics).forEach(([name, value]) => {
      if (value !== undefined && onMetric) {
        onMetric(name, value);
      }
    });
  }, [metrics, onMetric]);

  useEffect(() => {
    // Log slow operations in development
    if (process.env.NODE_ENV === 'development') {
      const { lcp, fid, cls, fcp, ttfb } = metrics;
      
      if (lcp && lcp > 2500) {
        console.warn(`Slow LCP detected: ${lcp}ms (should be < 2500ms)`);
      }
      
      if (fid && fid > 100) {
        console.warn(`Slow FID detected: ${fid}ms (should be < 100ms)`);
      }
      
      if (cls && cls > 0.1) {
        console.warn(`High CLS detected: ${cls} (should be < 0.1)`);
      }
      
      if (fcp && fcp > 1800) {
        console.warn(`Slow FCP detected: ${fcp}ms (should be < 1800ms)`);
      }
      
      if (ttfb && ttfb > 600) {
        console.warn(`Slow TTFB detected: ${ttfb}ms (should be < 600ms)`);
      }
    }
  }, [metrics]);

  // Component doesn't render anything
  return null;
};